<p>
  {{'DELETEFILE.BODY' | translate }}
</p>
<input type="submit" value="{{'COMMON.YES' | translate}}" class="cb-btn" (click)="ok()"/>
<input type="submit" value="{{'COMMON.NO' | translate}}" class="cb-btn" (click)="no()"/>
